import { DEFAULT_DATE_TIME_RANGE } from '@modules/common/components/DateRangePicker/constants';
import {
  DEFAULT_ANOMALY_THRESHOLD,
  DEFAULT_COMPARE_DURATION_A_NAME,
  DEFAULT_COMPARE_DURATION_B_NAME,
  DEFAULT_COMPARE_FILTER_A_NAME,
  DEFAULT_COMPARE_FILTER_B_NAME,
  DEFAULT_QUANTIFY_SORT_BY,
  DEFAULT_QUANTIFY_TOP_SELECTION_VALUE,
} from '@modules/quantify/constants';
import { AggregatePeriod } from 'v2/core/entities';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

import { QuantifyState, VisualisationType } from './types';

export const quantifyInitialState: QuantifyState = {
  query: {
    groupBy: null, // For "Show me" field, "Group By" was the old name
    shouldShowNormalisedValues: false,
    whereClauseConfig: null,
    duration: DEFAULT_DATE_TIME_RANGE,
    compareTo: null,
    formulaID: EQLFunctionName.Count,
    measuredAsCriteria: null,
    denominatorWhereClause: null,
  },
  metadata: {
    visibleDataPoints: [],
    shouldShowAllValues: true,
    sortBy: DEFAULT_QUANTIFY_SORT_BY,
    activeVisualisationType: VisualisationType.BAR,
    aggregatePeriod: AggregatePeriod.MONTH,
    shouldShowCooccurringDataPoints: true,
    shouldShowTopDataPoints: true,
    topDataPointsSelectionCount: DEFAULT_QUANTIFY_TOP_SELECTION_VALUE,
    shouldShowAnomalies: false,
    anomalyThreshold: DEFAULT_ANOMALY_THRESHOLD,
    shouldShowCategories: false,
    compareQBField: {
      compareQBFieldAName: DEFAULT_COMPARE_FILTER_A_NAME,
      compareQBFieldBName: DEFAULT_COMPARE_FILTER_B_NAME,
    },
    compareDurationField: {
      compareDurationAName: DEFAULT_COMPARE_DURATION_A_NAME,
      compareDurationBName: DEFAULT_COMPARE_DURATION_B_NAME,
    },
  },
  visual: {
    hasQueryChanged: false,
    hasMetadataChanged: false,
    isEditMode: true,
    isTableQueryInProgress: false,
    isChartQueryInProgress: false,
    isCustomAnomalyThresholdSelected: false,
    pageNumber: 1,
    timeRangeTraversal: {
      originalDuration: DEFAULT_DATE_TIME_RANGE,
      traverseCount: 0,
    },
    totalAggregateHits: Number.MAX_SAFE_INTEGER,
    searchTerm: '',
    tableAggregateHits: Number.MAX_SAFE_INTEGER,
    shouldHighlightWhereClauseField: false,
    shouldHighlightDurationField: false,
  },
  reportData: {
    quantify: {
      tableRows: null,
      chartDataPoints: null,
      aggregateFormulaResponse: null,
      valueRange: null,
    },
    compare: {
      tableRows: null,
      chartDataPoints: null,
      aggregateFormulaResponse: null,
      valueRange: null,
    },
  },
  misc: {
    compareQBFieldA: null,
    compareQBFieldB: null,
  },
};
